import { find } from 'lodash';
import { Allocation, ReceivedVariations, Variations, VariationType } from './types';

export const filterData = (data: Record<string, any>): Allocation[] => {
  return (
    Object.entries(data)
      // omit all flags that are not experiments
      .filter(([key]) => key.startsWith('experiment-'))
      // return a nice and tidy array
      .map(([key, value]) => ({
        experimentIdentifier: key,
        group: String(value) as VariationType,
      }))
  );
};

export const isValidVariation = (receivedVariations: ReceivedVariations, currentExperimentGroup: VariationType) =>
  receivedVariations.some((variation) => variation.group === currentExperimentGroup) ||
  currentExperimentGroup === Variations.FLAG_CONTROL;

export const getExperiment = (id: string, experiments: Allocation[]) => {
  return find(experiments, { experimentIdentifier: id }) as Allocation;
};

export const createURL = (
  baseUrl: string,
  requestParams: { [key: string]: string | number | null | undefined },
): string => {
  const url = new URL(baseUrl);
  for (const key in requestParams) {
    if (requestParams.hasOwnProperty(key) && !!requestParams[key]) {
      url.searchParams.append(key, String(requestParams[key])!);
    }
  }
  return url.href;
};
